import PinnedMessage from './PinnedMessage';

export default PinnedMessage;
